import styled, { css } from 'styled-components';
import { labelSizesThemes } from './types';
export const FormLabelContainerStyling = ($size, theme) => {
    const sizeTheme = labelSizesThemes[$size];
    return css `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing[sizeTheme.marginBlockEnd]}px;
    margin-block-end: ${theme.spacing[sizeTheme.marginBlockEnd]}px;
  `;
};
export const FormLabelContainer = styled.div `
  ${({ $size, theme }) => FormLabelContainerStyling($size, theme)}
`;
export const FormLabelTitle = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
